import { render, staticRenderFns } from "./PedidoPendenteIntegracao.vue?vue&type=template&id=a41e1348"
import script from "./PedidoPendenteIntegracao.vue?vue&type=script&lang=js"
export * from "./PedidoPendenteIntegracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports